import React from 'react';
import ViewContainer from '../components/patterns/ViewContainer';
import { Link } from 'react-router-dom';
import { Headline, Body2 } from '../components/FontStyles';
import SettingsVerification from '../components/elements/rxflow/SettingsVerification';
import settings1 from '../images/settings1.png';
import { Flex, Box } from 'rebass';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

class UserSettings extends React.Component {
  render() {
    this.props.changeNavVisibility(true);
    console.log(this.props.data);
    const userSettings = this.props.data[this.props.data.length - 1].allSettings;

    const theme = createMuiTheme({
      palette: {
        primary: {
          light: '#fff',
          main: '#627CFF',
          dark: '#4f6a92'
        },
        secondary: {
          main: '#f44336'
        },
        text: {
          primary: '#4f6a92',
          secondary: '#4f6a92'
        }
      },
      typography: {
        useNextVariants: true
      }
    });
    return (
      <ViewContainer width={100}>
        <Flex width={1} flexWrap="wrap" mt={2} justifyContent="center">
          <Body2>
            <MuiThemeProvider theme={theme}>
              <SettingsVerification
                values={userSettings}
                titleValue={`Current User Settings for ${userSettings.firstName} ${userSettings.lastName}`}
              />
            </MuiThemeProvider>
          </Body2>

          <Link to="/settings-2">
            <Box width={1}></Box>
          </Link>
        </Flex>
      </ViewContainer>
    );
  }
}

export default UserSettings;
